import React from 'react'
import Breadcrumbs from '../components/Breadcrumbs/Breadcrumbs'

import './styles/About.scss'

const About = () => {
  return (
    <main>
      <Breadcrumbs/>
      <section>
        <div className="about">
          <div className="about-header">
            <div className="container">
              <h1>About Us</h1>
            </div>
          </div>
          <div className="about_dark">
            <div className="container">
              <div className="about-block">
                <div className="about-info">
                  <h2>A Family That Keeps On Growing</h2>
                  <p>We always aim to please the home market, supplying great computers and hardware at great prices to non-corporate customers, through our large Melbourne CBD showroom and our online store.</p>
                  <p>Shop management approach fosters a strong customer service focus in our staff. We prefer to cultivate long-term client relationships rather than achieve quick sales, demonstrated in the measure of our long-term success.</p>
                </div>
                <div className="about-image">
                  <div className="image">
                    <img src={process.env.PUBLIC_URL + '/images/store.png'}  alt="Store" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="about_light">
            <div className="container">
              <div className="about-block about-block_short">
                <div className="about-image">
                  <div className="image">
                    <img src={process.env.PUBLIC_URL + '/images/about_keyboard.png'}  alt="Case" />
                  </div>
                </div>
                <div className="about-info">
                  <h2>shop.com</h2>
                  <p>Shop is a proudly Australian owned, Melbourne based supplier of I.T. goods and services, operating since 1991. Our client base encompasses individuals, small business, corporate and government organisations. We provide complete business IT solutions, centred on high quality hardware and exceptional customer service.</p>
                </div>
              </div>
            </div>
          </div>
          <div className="about_dark">
            <div className="container">
              <div className="about-block about-block">
                <div className="about-info">
                  <h2>You're In Safe Hands</h2>
                  <p>Experience a 40% boost in computing from last generation. MSI Desktop equips the 10th Gen. Intel® Core™ i7 processor with the upmost computing power to bring you an unparalleled gaming experience.</p>
                  <p>*Performance compared to i7-9700. Specs varies by model.</p>
                </div>
                <div className="about-image">
                  <div className="image">
                    <img src={process.env.PUBLIC_URL + '/images/case.png'}  alt="Case" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="about-light">
            <div className="container">
              <div className="about-block about-block_short">
                <div className="about-image">
                  <div className="image">
                    <img src={process.env.PUBLIC_URL + '/images/case1.png'}  alt="Case" />
                  </div>
                </div>
                <div className="about-info">
                  <h2>The Highest Quality of Products</h2>
                  <p>We guarantee the highest quality of the products we sell. Several decades of successful operation and millions of happy customers let us feel certain about that. Besides, all items we sell pass thorough quality control, so no characteristics mismatch can escape the eye of our professionals.</p>
                </div>
              </div>
            </div>
          </div>
          <div className="about_dark">
            <div className="container">
              <div className="about-block about-block">
                <div className="about-info">
                  <h2>Delivery to All Regions</h2>
                  <p>We deliver our goods all across Australia. No matter where you live, your order will be shipped in time and delivered right to your door or to any other location you have stated. The packages are handled with utmost care, so the ordered products will be handed to you safe and sound, just like you expect them to be.</p>
                </div>
                <div className="about-image">
                  <div className="image">
                    <img src={process.env.PUBLIC_URL + '/images/case2.png'}  alt="Case" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  )
}

export default About